import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ChangePasswordService } from './change-password.service';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatCardModule, MatInputModule, MatButtonModule, MatFormFieldModule, MatIconModule],
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  public changePasswordForm: FormGroup = new FormGroup<any>({});
  public codeUser: string | null = localStorage.getItem('CODIGO_CADASTRO_GERAL');

  // Password visibility controls
  public showNewPassword: boolean = false;
  public showConfirmPassword: boolean = false;

  // Password strength
  public passwordStrength: 'weak' | 'medium' | 'strong' = 'weak';
  public passwordStrengthPercentage: number = 0;

  // Loading state
  public isLoading: boolean = false;

  constructor(
    private service: ChangePasswordService,
    private router: Router
  ) { }

  public changePassword(): void {
    const newPass = this.changePasswordForm.value.newPassword;
    const confirmNewPass = this.changePasswordForm.value.confirmNewPassword;
    this.validatePasswordChange(newPass, confirmNewPass);
  }

  protected validatePasswordChange(newPassword: string, confirmPassword: string): void {
    this.isLoading = true;
    this.service.showSpinner();
    this.service.setNewPassword(newPassword, confirmPassword).subscribe((data) => {
      this.service.hideSpinner();
      this.isLoading = false;
      this.service.toasterSuccess('Senha alterada com sucesso!');
      this.router.navigate(['principal/dashboard']);
    }, (err) => {
      this.service.hideSpinner();
      this.isLoading = false;
      this.service.toasterWarning(err.error ?? 'Erro ao alterar a senha');
    });
  }

  public validatePasswords(): boolean {
    if (
      (this.changePasswordForm.value.newPassword === this.changePasswordForm.value.confirmNewPassword) &&
      (this.changePasswordForm.value.newPassword !== '') &&
      (this.changePasswordForm.value.confirmNewPassword !== '')
      ) {
      return true;
    } else {
      return false;
    }
  }

  validatePasswordsConfirm(): boolean {
    return this.changePasswordForm.value.newPassword !== this.changePasswordForm.value.confirmNewPassword;
  }

  getErrorMessage(): string {
    return 'As senhas não correspondem';
  }

  // Toggle password visibility
  public togglePasswordVisibility(field: 'new' | 'confirm'): void {
    if (field === 'new') {
      this.showNewPassword = !this.showNewPassword;
    } else {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }

  // Handle password input for strength calculation
  public onPasswordInput(event: any): void {
    const password = event.target.value;
    this.calculatePasswordStrength(password);
  }

  // Calculate password strength
  private calculatePasswordStrength(password: string): void {
    let score = 0;

    // Length check
    if (password.length >= 8) score += 25;
    if (password.length >= 12) score += 25;

    // Character variety checks
    if (/[a-z]/.test(password)) score += 10; // lowercase
    if (/[A-Z]/.test(password)) score += 10; // uppercase
    if (/[0-9]/.test(password)) score += 10; // numbers
    if (/[^A-Za-z0-9]/.test(password)) score += 10; // special characters

    // Complexity bonus
    if (password.length >= 8 && /[a-z]/.test(password) && /[A-Z]/.test(password) && /[0-9]/.test(password)) {
      score += 10;
    }

    this.passwordStrengthPercentage = Math.min(score, 100);

    if (score < 40) {
      this.passwordStrength = 'weak';
    } else if (score < 70) {
      this.passwordStrength = 'medium';
    } else {
      this.passwordStrength = 'strong';
    }
  }

  // Get password strength text
  public getPasswordStrengthText(): string {
    switch (this.passwordStrength) {
      case 'weak':
        return 'Fraca';
      case 'medium':
        return 'Média';
      case 'strong':
        return 'Forte';
      default:
        return '';
    }
  }

  ngOnInit(): void {
    this.changePasswordForm = new FormGroup({
      newPassword: new FormControl('', [Validators.required]),
      confirmNewPassword: new FormControl('', [Validators.required])
    });
  }

  returnToDashboard(): void {
    this.router.navigate(['principal/dashboard']);
  }

}
